import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 68.796 69.047",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 68.796 69.047\" id=\"icon-plus\">\n<g id=\"icon-plus_plus\">\n\t<line style=\"fill:none;stroke:#808080;stroke-width:10;stroke-miterlimit:10;\" x1=\"34.39\" y1=\"0\" x2=\"34.39\" y2=\"69.047\" />\n\t<line style=\"fill:none;stroke:#808080;stroke-width:10;stroke-miterlimit:10;\" x1=\"0\" y1=\"34.529\" x2=\"68.796\" y2=\"34.529\" />\n</g>\n<g id=\"icon-plus_Layer_1\">\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol